// extracted by mini-css-extract-plugin
export default {"pendingWrapper":"CaseAccount_pendingWrapper__q6T97","pendingText":"CaseAccount_pendingText__BT2S+"};